import React, { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import HeatMap from "react-heatmap-grid";
// Components
import { GraphicContainer, GraphicRotateDiv, HeaderDiv, GraphicTitle, LegendDiv, LegendColorDiv, GraphicSizeDiv, AxisX } from "./styles";

const HandTrackingPlot = forwardRef(({ recordings }, ref) => {
  const [positions, setPositions] = useState([]);
  const [handTrackingValues, setHandTrackingValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let handTrackingRecordings = [];

    recordings.forEach((recording, i) => {
      positions.push(i + 1);

      handTrackingRecordings.push(
        !recording.hasOwnProperty("handTrackingState") || recording.handTrackingState.toLowerCase() === "off" ? "Off" : "On"
      );
    });

    setPositions(positions);
    setHandTrackingValues(handTrackingRecordings);

    return () => {
      setPositions([]);
      setHandTrackingValues([]);
    };
  }, [recordings]);

  return (
    <GraphicContainer ref={ref}>
      <GraphicRotateDiv>
        <HeaderDiv>
          <GraphicTitle>{t("reports.handTrackingGraphic.title")}</GraphicTitle>
        </HeaderDiv>
        <LegendDiv>
          <LegendColorDiv margin="0 5px 0 0" color="#fff" border>
            +
          </LegendColorDiv>
          <p>On</p>
          <LegendColorDiv margin="0 5px 0 10px" color="#fff" border />
          <p>Off</p>
        </LegendDiv>
        <GraphicSizeDiv align={positions.length >= 32 ? "left" : "center"}>
          <HeatMap
            xLabels={positions}
            yLabels={[""]}
            yLabelWidth={0}
            data={[handTrackingValues]}
            squares
            height={25}
            xLabelsLocation={"bottom"}
            cellStyle={() => ({
              background: "#fff",
              border: "1px solid #e0e0e0",
              fontSize: "18px",
              paddingBottom: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "default",
            })}
            cellRender={(value) => (value === "On" ? "+" : "")}
          />
        </GraphicSizeDiv>
        <AxisX>{t("reports.handTrackingGraphic.axisX")}</AxisX>
      </GraphicRotateDiv>
    </GraphicContainer>
  );
});

export default HandTrackingPlot;
